import { App } from "vue";

class _ThemeColorManager {

    /** デフォルト定義 */
    private defaultThemeColor;

    /** 会社用定義 */
    private companyThemeColor;

    constructor() {
        // デフォルト定義読込
        this.defaultThemeColor = require("@/plugins/setting/theme/default.json");

        try {
            // 会社用定義読込
            const company = process.env.VUE_APP_COMPANY?.toLowerCase();
            if (company) {
                this.companyThemeColor = require(`@/plugins/setting/theme/${company}.json`);
            } else {
                this.companyThemeColor = this.defaultThemeColor;
            }
        } catch (e) {
            // エラーの場合は、デフォルト定義を設定
            this.companyThemeColor = this.defaultThemeColor;
        }
    }

    /**
     * テーマカラー取得
     * 
     * @returns テーマカラー
     */
    getThemeColor(): string {
        return this.companyThemeColor?.themeColor;
    }
}

// クロージャを使用
export function createThemeColor() {
    const manager = new _ThemeColorManager();
    function getThemeColor() {
        return manager.getThemeColor();
    }
    return getThemeColor;
}

export const getThemeColor = createThemeColor();
